import { Component, h } from 'preact'
import { BadgeList } from './index'
import BadgesOverviewPanel from './BadgesOverviewPanel'
import axios from 'axios'

interface Props {
    userId: string
}

interface State {
    badgesList: BadgeList | [],
    loading: boolean
}

class BadgeOverviewModal extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      badgesList: [],
      loading: true
    }
  }

  async componentDidMount () {
    const { userId } = this.props
    await axios.get(`/settings/badge/getBadgesList?userid=${userId}`)
      .then((response) => this.setState({ badgesList: response.data, loading: false }))
      .catch(() => this.setState({ loading: false }))
  }

  render (props: Props, state: State) {
    return (<BadgesOverviewPanel
      badgeList={state.badgesList}
      loading={state.loading}
    />)
  }
}

export default BadgeOverviewModal
